export function initSurvey(conversationId, questionMain, pendingSurveyId, active) {
  return {
    type: "@survey/INIT_SURVEY",
    payload: {
      conversationId,
      questionMain,
      pendingSurveyId,
      active,
    },
  };
}
